import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {GetParams, GetResponse, PostResponse, Shipping} from '@app/shared';
import {Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class ShippingService {

  shippingUrl = environment.coreApiBaseUrl + '/api/shipping';

  constructor(private http: HttpClient) { }

  /** Metodos de obtener/crear/actualizar/eliminar la Naviera **/
  getShipping(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.shippingUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createShipping(newShipping: {name: string, scac: string}): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.shippingUrl, newShipping);
  }

  updateShipping(Shipping: Shipping): Observable<any> {
    return this.http.put(this.shippingUrl, Shipping);
  }

  deleteShipping(ShippingIds: number[]): Observable<any> {
    return this.http.delete(this.shippingUrl, {body: {ids: ShippingIds}});
  }
}
